<template>
    <div class="webfooter">
        <div id="end_div">
            <div class="container">
                <div class="row end-div">
                    <div class="col-md-3 new-col-md-3">
                        <p class="title-p">导航</p>
                        <p class="first-title-1"><a class="conmmon-a" href="http://www.hffss.com/">首页</a> </p>
                        <p><a href="http://www.hffss.com/news/c-3" class="conmmon-a">海峰资讯</a></p>
                        <p><a href="http://www.hffss.com/solution/Index" class="conmmon-a">解决方案</a> </p>
                        <p><a href="Http://csc.hffss.com" class="conmmon-a">客户平台</a></p>
                        <p><a href="/Rules/Index/3031" class="conmmon-a">国际法规</a> </p>
                        <p><a href="http://wiki.hffss.com/Home/Choice" class="conmmon-a">精华解答</a></p>
                    </div>
                    <div class="col-md-3 new-col-md-3">
                        <p class="title-p">海峰科技</p>
                        <p class="first-title-1"><a href="http://www.hffss.com/AboutUs" class="conmmon-a">关于海峰</a>  </p>
                        <p><a href="http://www.hffss.com/Common/Page/14" class="conmmon-a">加入海峰</a></p>
                        <p><a href="http://www.hffss.com/AboutUs/contactus" class="conmmon-a">联系海峰</a> </p>
                        <p><a href="http://www.hffss.com/Common/Page/13" class="conmmon-a">法律声明</a></p>
                    </div>
                    <div class="col-md-3 new-col-md-3">
                        <p class="title-p">联系我们</p>
                        <p class="first-title-1">北京：010-68311878（疫情期间,请拨打：13901006625）</p>
                        <p>上海：</p>
                        <p>深圳：0755-23895517</p>
                        <p style="font-size:10px;">(工作时间：周一至周五9:00-18:00)</p>
                        <p class="end-p"> 地址：北京市西城区车公庄大街乙5号鸿儒大厦B座3层 </p>
                        <p>
                            <a class="conmmon-a" href="http://weibo.com/5838324786/" target="_blank">
                                <i style="font-size:33px;" class="icon iconfont icon-xinlangweibo"></i>
                            </a>
                            <a class="conmmon-a" data-toggle="modal" data-target="#editModal" href="#"><i style="font-size:33px;" class="icon iconfont icon-weixin"></i></a>
                        </p>
                    </div>
                    <div class="col-md-3 new-col-md-3">
                    <p class="title-p">友情链接</p>
                        <p class="first-title-1"><a href="http://www.csrc.gov.cn/pub/newsite/" target="_blank">中国证券监督管理委员会</a></p>
                    <p><a href="http://www.amac.org.cn/" target="_blank">中国证券投资基金业协会</a></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerDiv">
            <div class="container text-center">
                <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank">©京ICP备15014465号-1 Copyright 2015年北京海峰科技有限责任公司版权所有</a>
            </div>
            
        </div>
        
    </div>
</template>

<script>
export default {
    name:'webFooter',
    data(){
        return{
        }
    }

}

</script>
<style scoped lang='scss'>
.webfooter{
    position: absolute;
    left: 0;
    right: 0;
}
#end_div{
    background-image: url(../assets/images/584594078781147375.png);
    background-size: cover;
    padding-bottom: 50px;
    text-align: left;
    @media screen and (min-width: 1200px) {
        .container{
            padding-right: 15px;
            padding-left: 15px;
            margin-right: auto;
            margin-left: auto;
        }
        .row{
            display: flex;
            justify-content:space-between;
            margin-right: -15px;
            margin-left: -15px;
            padding-top: 5em;
        }
    }
    @media screen and (min-width: 992px){
        .col-md-3 {
            width: 20%;
        }
    }
}
.title-p {
    color: #fff;
    font-size: 19px;
}
.first-title-1 {
    padding-top: 18px;
}
.new-col-md-3 p a {
    color: #c6c6c6;
    margin-top: 5px;
    font-size: 14px;
}
.new-col-md-3 {
    color: #c6c6c6;
    margin-top: 5px;
    font-size: 14px;
}
.footerDiv{
    background: #000;
    line-height: 35px;
    color: #fff;
    font-size: 12px;
}
a{
    text-decoration: none;
    color: #428bca;
    text-decoration: none !important;
}
a:hover {
    color: #2a6496;
}
</style>